export default {
    XS: 'xs',
    S: 's',
    L: 'l',
};
